<template>
  <div style="width: 100%; height: 100%; position: relative">
    <!-- 柱形图3 -->
    <div class="chartsBtn">
      <div
        class="chartsbtn-item"
        v-for="(item, index) in powerData"
        :key="index"
        @click="powerClick(item, index)"
        :class="{ 'btn-act': powerIndex === index }"
      >
        {{ item.title }}
      </div>

      <!-- <div class="chartsbtn-item" @click="numberClick">签约数量</div> -->
      <!-- <div class="chartsbtn-item" @click="mianduimian">面对面</div> -->
    </div>
    <div class="chartsPic">
      <div class="circular">
        <div class="cir-item">
          <div class="cir-item-text">跟进(1348)</div>
          <img src="../assets/img/juxing.png" alt="" class="circular1" />
        </div>
        <div class="cir-item">
          <img src="../assets/img/juxing2.png" alt="" class="circular2" />
        </div>
        <div class="cir-item">
          <img src="../assets/img/juxing3.png" alt="" class="circular3" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      powerData: [
        {
          id: 1,
          title: "全部",
        },
        {
          id: 2,
          title: "电话",
        },
        {
          id: 3,
          title: "微信",
        },
        {
          id: 4,
          title: "面对面",
        },
      ],
      powerIndex: 0,
    };
  },
  methods: {
    // 销售强度
    powerClick(item, index) {
      this.powerIndex = index;
    },
  },
};
</script>

<style>
.cir-item-text {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 48%);
  font-size: 15px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
}
.chartsPic {
  display: flex;
  justify-content: center;
  align-items: center;
}
.circular1 {
  width: 312px;
  height: 72px;
}
.circular2 {
  width: 235px;
  height: 66px;
  margin-top: -20px;
}
.circular3 {
  width: 158px;
  height: 51px;
  margin-top: -12px;
}
.circular {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 50%;
  transform: translate(0px, -50%);
}
.chartsBtn {
  display: flex;
  align-items: center;
  margin: 30px 0 0 20px;
  /* background: red; */
}
.chartsbtn-item {
  margin-right: 20px;
  border-radius: 20px;
  padding: 5px 12px;
  color: #7abfe9;
  background: #0a1162;
  cursor: pointer;
  -webkit-box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.3);
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.3);
}
.btn-act {
  background: #1e67c5 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/columnCharts3.vue